export default __webpack_public_path__ + "static/main-216c6c4487612edb7cb4fb5d0aea1b74.webp";